import { createAction } from '@reduxjs/toolkit';

import { SET_DEVICE, type Device } from './types';

export const setDevice = createAction<Device, typeof SET_DEVICE>(SET_DEVICE);
